import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { FAQ as FAQ_DATA, WHATSAPP_LINK } from '../data/mock';

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 md:py-36 relative">
      <div className="thesis-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-4 md:sticky md:top-32 self-start">
            <span className="font-mono-label text-[#8E8B85]">(08) — FAQ</span>
            <h2 className="mt-3 font-display-tight text-[44px] md:text-[68px] leading-[0.92] text-[#F5F1E8]">
              Perguntas <span className="font-serif-italic kinetic-grad">frequentes.</span>
            </h2>
            <p className="mt-5 text-[15px] text-[#8E8B85] max-w-[320px] leading-relaxed">
              Não achou o que procurava? Sua dúvida vira mensagem direta no WhatsApp.
            </p>
            <a
              href={WHATSAPP_LINK('Tenho uma dúvida sobre os planos.')}
              target="_blank" rel="noopener noreferrer"
              className="btn-secondary cursor-hover mt-7"
            >
              Dúvidas? WhatsApp
            </a>
          </div>

          <div className="md:col-span-8">
            {FAQ_DATA.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="reveal border-b border-white/8">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="cursor-hover w-full flex items-center justify-between gap-6 py-7 text-left group"
                  >
                    <div className="flex items-start gap-5">
                      <span className="font-mono-label text-[#8E8B85] mt-1.5">0{i + 1}</span>
                      <span className={`font-display-tight text-[22px] md:text-[30px] leading-tight transition-colors duration-300 ${isOpen ? 'text-[#C8FF61]' : 'text-[#F5F1E8] group-hover:text-[#C8FF61]'}`}>
                        {item.q}
                      </span>
                    </div>
                    <span className={`shrink-0 w-11 h-11 rounded-full border flex items-center justify-center transition-all duration-500 ${
                      isOpen ? 'bg-[#C8FF61] border-[#C8FF61] text-[#0A0B0E] rotate-180' : 'border-white/25 text-[#F5F1E8]'
                    }`}>
                      {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  <div className={`grid transition-all duration-500 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 pb-8' : 'grid-rows-[0fr] opacity-0'}`}>
                    <div className="overflow-hidden">
                      <p className="pl-12 pr-8 text-[16px] leading-relaxed text-[#8E8B85] max-w-[640px]">
                        {item.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
